import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "2px 4px 30px rgba(0, 0, 0, 0.05)",
    marginBottom: "20px",
    minHeight: "100px", // matches Materiality Matrix
  },

  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontWeight: "bold",
  },

  headings: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#000",
    textAlign: "center",
  },

  // 🟣 Quadrant labels (Leaders, Niche Players etc.)
  labelContainer: {
    position: "absolute",
    top: 20,
    left: 40,
    width: 800,
    height: 600,
    pointerEvents: "none",
  },

  quadrantLabel: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#7B1FA2", // Maroon
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
  },

  // 🟡 Legend styling (supplier names + colors)
  legendContainer: {
    marginLeft: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "8px",
  },

  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  legendColor: {
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    display: "inline-block",
  },
  chartWrapper: {
    width: "800px",
    height: "600px",
    position: "relative",
    border: "2px solid black", // 💡 Box-like border
    overflow: "hidden", // ensures labels don’t leak outside
    margin: "0 auto", // centers it
  },
  topHeading: {
    fontWeight: "400",
    fontSize: "18px",
  },
}));

export default useStyles;
